
export default {
  required: (value, message = undefined) =>
    !!value || message || 'This field is required.',
  email: (value, message = undefined) =>
    /.+@.+\..+/.test(value) || message || 'Please enter a valid email address.',
  minlength: (value, minlength, message = undefined) => {
    const length = Array.isArray(value) ? value.length : value.length
    return (
      length >= minlength ||
      message ||
      `Please enter at least ${minlength} characters.`
    )
  },
  maxlength: (value, maxlength, message = undefined) => {
    const length = Array.isArray(value) ? value.length : value.length
    return (
      length <= maxlength ||
      message ||
      `Please enter no more than ${maxlength} characters.`
    )
  },
  url: (value, message = undefined) => {
    return (
      /^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})).?)(?::\d{2,5})?(?:[/?#]\S*)?$/i.test(
        value
      ) ||
      message ||
      'Please enter a valid URL.'
    )
  },
  number: (value, message = undefined) => {
    return (
      /^(?:-?\d+|-?\d{1,3}(?:,\d{3})+)?(?:\.\d+)?$/.test(value) ||
      message ||
      'Please enter a valid number.'
    )
  },
  digits: (value, message = undefined) => {
    return /^\d+$/.test(value) || message || 'Please enter only digits.'
  },
  equalTo: (value, getCompareValue, message = undefined) => {
    const compareValue =
      typeof getCompareValue === 'function'
        ? getCompareValue()
        : getCompareValue
    return (
      value === compareValue || message || 'Please enter the same value again.'
    )
  },
  min: (value, min, message = undefined) => {
    return (
      (value && value >= min) ||
      message ||
      `Please enter a value greater than or equal to ${min}.`
    )
  },
  max: (value, max, message = undefined) => {
    return (
      (value && value <= max) ||
      message ||
      `Please enter a value less than or equal to ${max}.`
    )
  }
}
